import {
  APPROVE_PENDING_REQUEST_REQUEST,
  APPROVE_PENDING_REQUEST_SUCCESS,
  APPROVE_PENDING_REQUEST_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const approvePendingRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPROVE_PENDING_REQUEST_REQUEST:
      return { ...state, loading: true, error: null };
    case APPROVE_PENDING_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case APPROVE_PENDING_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default approvePendingRequestReducer;
